import styled, { css } from 'vue-styled-components';
import {
    TOOLTIP_CONTENT,
    FLEX_CENTER_DIV,
    FLEX_VERTICAL_CENTER_DIV,
    GRAY_100_DIV,
    ICON_WRAPPER,
    FLEX_DIV,
    WIDTH_100_DIV,
} from '@styles/common.styled.component';

import {
    applyHoverAndPress,
    RespondMobile,
    COLORS,
    square,
    GRAY,
    BLUE,
    RED,
} from '@styles/common.styled';

export const Wrapper = styled('div', { hide: Boolean })`
    will-change: contents;
    opacity: 1;

    ${({ hide }) =>
        hide &&
        css`
            min-height: calc(100vh - 12px);
            opacity: 0;
            overflow: hidden;
        `};

    .is-printing.widgets-draggable-area {
        padding-left: 28px;
        padding-right: 28px;
    }

    ${RespondMobile`
        margin-top: 150px;
    `}
`;

export const FlexBox = styled(FLEX_DIV, {
    isPc: Boolean,
    align: String,
    cursor: Boolean,
    margin: String,
    justifyContent: String,
    width: String,
})`
    align-items: flex-start;
    ${({ cursor }) =>
        cursor &&
        css`
            cursor: pointer;
        `}
    ${RespondMobile`
        padding-bottom: 10px;
        ${({ isPc }) =>
            isPc &&
            css`
                display: none;
            `}
    `};
    ${({ align }) =>
        align &&
        css`
            align-items: ${align};
        `}
    ${({ margin }) =>
        margin &&
        css`
            margin: ${margin};
        `}
    ${({ justifyContent }) =>
        justifyContent &&
        css`
            justify-content: ${justifyContent};
        `}
    ${({ width }) =>
        width &&
        css`
            width: ${width};
        `};
    svg,
    img.adverity-icon {
        position: relative;
        ${square(16)};
        flex-shrink: 0;
        margin-right: 5px;
        fill: ${COLORS['gray-100']};

        &.logo {
            margin-right: 0px;
        }
        &.instagram {
            fill: #8021b4;
        }
    }
`;

export const Img = styled('div', { src: String })`
    width: 95px;
    height: 95px;
    border: solid 1px rgba(0, 0, 0, 0.05);
    ${({ src }) =>
        src &&
        css`
            background: no-repeat center / cover url('${src}');
        `}
    margin-right: 25px;
    ${RespondMobile`
        margin-right: 13px;
    `}
`;

export const Background = styled.div`
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 4;
    ${RespondMobile`
        top: 56px;
        height: calc(100vh - 56px);
    `}
`;

export const DropdownList = styled('div', {
    top: Number,
    right: Number,
    left: Number,
    isMarginSet: Boolean,
    isAlignSet: Boolean,
})`
    position: absolute;
    border-radius: 4px;
    width: 318px;
    animation-duration: 0.2s;
    border-radius: 2px;
    box-shadow: 0 8px 12px 0 rgba(0, 0, 0, 0.1);
    border: 1px solid ${COLORS['gray-30']};
    background-color: ${COLORS['white']};
    z-index: 5;
    display: block;
    top: 35px;
    right: auto;

    ${({ top }) =>
        top &&
        css`
            top: ${top}px;
        `};
    ${({ right }) =>
        right &&
        css`
            right: ${right}px;
        `};
    ${({ isMarginSet }) =>
        isMarginSet &&
        css`
            top: 40px;
            max-height: 300px;
            right: auto;
            max-width: 528px;
            width: auto;
            overflow: auto;

            ${RespondMobile`
                margin: 0;
                left: auto;
                right: auto;
                top: auto;
                margin-top: 100px;
                margin-left: 140px;
            `};
        `};

    ${({ isAlignSet }) =>
        isAlignSet &&
        css`
            left: 0px;
            right: 0px;
        `};
`;

export const DropdownItem = styled(FLEX_VERTICAL_CENTER_DIV, {
    active: Boolean,
    dragCursor: String,
})`
    justify-content: space-between;
    max-width: 528px;
    padding: 0 16px;
    height: 36px;
    cursor: pointer;
    transition: background-color 0.2s;
    flex-shrink: 0;
    ${applyHoverAndPress('white', 'background-color')};
    color: ${COLORS['gray-100']};
    font-size: 14px;
    font-weight: 400;

    svg {
        width: 16px;
        height: 16px;
        flex-shrink: 0;
        position: relative;
        ${({ active }) =>
            active &&
            css`
                fill: ${COLORS['blue-60']};
            `};

        &.move {
            fill: ${COLORS['gray-30']};
        }
    }

    ${({ active }) =>
        active &&
        css`
            color: ${COLORS['blue-60']};
            font-weight: 500;
        `};
    ${({ dragCursor }) =>
        dragCursor &&
        css`
            cursor: ${dragCursor};
        `};
`;

export const DropdownItemText = styled(WIDTH_100_DIV)`
    font-size: 14px;
    overflow: hidden;
    text-align: left;
    text-overflow: ellipsis;
    white-space: nowrap;

    ${RespondMobile`
        font-size: 14px;
    `};
`;

export const DropdownItemCheck = styled(FLEX_CENTER_DIV)`
    margin-left: auto;
    svg {
        ${square(16)};
    }
`;

export const DropdownSearchLabel = styled('label')`
    width: 284px;
    height: 32px;
    border: 0;
    margin: 12px 16px;
    border: ${COLORS['gray-10']};
    background-color: ${COLORS['gray-10']};
    border-radius: 2px;
    padding: 0 10px;
    display: flex;
    align-items: center;
    svg {
        width: 16px;
        height: 16px;
        fill: ${COLORS['gray-30']};
        position: relative;
    }
    padding: 0;

`;

export const CenterDiv = styled(FLEX_CENTER_DIV)`
    width: 100%;
    min-height: 150px;

    ${RespondMobile`
        min-height: 250px;
    `}
`;

export const TooltipContent = styled(TOOLTIP_CONTENT)`
    min-width: 50px;
`;

export const FlexCenter = styled(FLEX_VERTICAL_CENTER_DIV, {
    cursor: String,
    width: String,
})`
    ${({ cursor }) =>
        cursor &&
        css`
            cursor: ${cursor};
        `};
    ${({ width }) =>
        width &&
        css`
            width: ${width};
        `};
`;

export const IconWrapper = ICON_WRAPPER;

export const DropdownIconWrapper = styled(FLEX_VERTICAL_CENTER_DIV)`
    svg {
        width: 16px;
        height: 16px;
        fill: ${COLORS['gray-100']};
        margin-right: 8px;
    }
`;

export const DropdownOptionText = styled(GRAY_100_DIV)`
    font-size: 13px;
    font-weight: 500;
`;

export const DropdownCustomStyles = {
    menuItemHeight: '36px',
    menuItem: css`
        .dropdown-option-text {
            padding: 0 16px;
        }
    `,
};

const WithWidgetProps = {
    cursor: String,
    shouldHide: Boolean,
    highlight: Boolean,
    mouseInside: Boolean,
    isResizableDisabled: Boolean,
    isHeaderEllipsis: Boolean,
    hasScroll: Boolean,
    widgetWidth: Number,
    isSimplifyMode: Boolean,
    widgetType: String,
};

export const WithWidget = styled(FLEX_DIV, WithWidgetProps)`
    ${({ widgetType }) =>
        widgetType === 'notepad' && `border-bottom: 5px solid #ffffff;`}

    position: relative;
    will-change: contents;
    height: 100%;

    &.widget--type__graph,
    &.widget--type__creative,
    &.widget--type__singleMetric,
    &.widget--type__graphBoxes {
        .widget--content-container {
            height: calc(100% - 50px);
        }
    }

    + .vue-resizable-handle {
        ${({ isSimplifyMode }) =>
            isSimplifyMode && 'visibility: hidden; transition: all 0.8s ease;'}
    }

    &::before {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        border-radius: 4px;
        box-shadow: 0 12px 36px 0 rgba(0, 84, 198, 0.15);
        border: solid 2px ${BLUE(30)};
        pointer-events: none;
        opacity: 0;
        z-index: 1;
    }

    .widget--body-container {
        &::after {
            content: '';
            position: absolute;
            left: 10px;
            right: 10px;
            top: 40px;
            bottom: 20px;
            opacity: 0;
            z-index: 1;
            pointer-events: none;
            background-color: transparent;
        }

        &.has-cover {
            &::after {
                opacity: 1;
                pointer-events: initial;
            }
        }
    }

    .widget--content-container {
        padding: ${({ widgetWidth = 0, widgetType = '' }) =>
            widgetType === 'graph' && widgetWidth <= 400 ? '0' : '0 12px'};
    }

    ${({ highlight }) =>
        highlight &&
        css`
            &::before {
                opacity: 1;
            }
        `};

    ${({ isResizableDisabled }) =>
        isResizableDisabled &&
        css`
            margin: 6px 0;
            padding-left: 28px;
            padding-right: 28px;
        `};

    &.is-printing {
        padding-left: 0;
        padding-right: 0;

        .widget--title-additionals {
            display: none;
        }
    }

    ${({ shouldHide }) =>
        shouldHide &&
        css`
            display: none;
        `};

    &:first-child {
        margin-top: 0;
        margin-bottom: 6px;
    }

    &:last-child {
        margin-bottom: 0;
    }

    &:empty {
        margin: 0;
        padding: 0;
        border: none;
    }

    h1 {
        color: #080a0d;
        font-size: 14px;
        font-weight: 600;
        align-items: center;
    }

    .widget--body-container {
        flex: 1;
        width: 100%;
        background-color: white;
        padding: ${({ highlight }) =>
            highlight ? '2px 0 12px 0' : '0px 0 12px 0'};
        height: 100%;

        ${({ isResizableDisabled }) =>
            isResizableDisabled &&
            css`
                border-radius: 4px;
                border: solid 1px ${GRAY(15)};
            `};

        ${({ hasScroll }) =>
            hasScroll &&
            css`
                overflow-y: auto;
                overflow-x: hidden;
                &::-webkit-scrollbar {
                    width: 6px;
                }
                &::-webkit-scrollbar-thumb {
                    background-color: ${COLORS['gray-25']};
                }
            `};
    }

    .widget--gear {
        margin-left: 6px;
        display: flex;

        .widget-setting-dropdown {
            padding: 0;
            width: 30px;
            height: 30px;
        }
        svg {
            &:focus {
                outline: none;
            }
        }
    }
`;

export const SubmitButtonWrapper = styled(FLEX_DIV)`
    width: 100%;
    justify-content: flex-end;
    padding: 12px 16px;

    button {
        width: 80px;
        height: 36px;
        font-size: 13px;
    }
`;
